import { Input, Component, OnInit } from "@angular/core";
import { CustomTranslatePipe } from "../../shared/custom-translate.pipe";
import { TranslateModule } from "@ngx-translate/core";
import { BaseLifeModifierClassComponent } from "./baseLifeModifier/baseLifeModifier.component";
import { BaseLifeClassComponent } from "./baseLife/baseLife.component";
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLinkBase, NgbNavLink, NgbNavContent, NgbNavOutlet } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-sms-retro-admin",
    templateUrl: "./retro-admin.component.html",
    styleUrls: ["./retro-admin.component.scss"],
    standalone: true,
    imports: [NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLinkBase, NgbNavLink, NgbNavContent, BaseLifeClassComponent, BaseLifeModifierClassComponent, NgbNavOutlet, TranslateModule, CustomTranslatePipe]
})
export class RetroAdminComponent implements OnInit {
  @Input() map: any;
  @Input() FeatureTable;
  @Input() FeatureLayer;
  @Input() Graphic;

  active = 1;
  ngOnInit(): void {
    this.active = 1;
  }
}
